import React, { Component } from 'react';

const withPostFetch = fetchFunction => BaseComponent =>
  class extends Component {
    state = {
      onLoad : false
    }

    postRequest = field => {
      return new Promise((resolve, reject) => {
        fetchFunction(field)
          .then(result => {
            this.setState({
              onLoad : false
            })
            resolve({ data: result.data });
          })
          .catch(error => {
            this.setState({
              onLoad : false
            })
            resolve({ error });
          });
      });
    };

    post = (field, callBack) => {
      this.setState({
        onLoad:true
      })
      this.postRequest(field).then(res => {
        callBack(res);
      });
    };
    postRequest1 = field => {
      return new Promise((resolve, reject) => {
        fetchFunction(field)
          .then(result => {
            this.setState({
              onLoad : false
            })
            resolve({ data: result });
          })
          .catch(error => {
            this.setState({
              onLoad : false
            })
            resolve({ error });
          });
      });
    };

    post1 = (field, callBack) => {
      this.setState({
        onLoad:true
      })
      this.postRequest1(field).then(res => {
        callBack(res);
      });
    };

    render() {
      const { onLoad } = this.state
      return <BaseComponent { ...this.props } post={ this.post } post1={this.post1} onLoad= { onLoad } />;
    }
  };

export default withPostFetch;
